module.exports = __webpack_public_path__ + "static/media/11798302_969817746372981_1505499503_n.0e0b5e3a.jpg";